module.exports = __webpack_public_path__ + "ic-insights-sales-white.svg?5362e3eee21c1a22074234c000b4f2d3";